// Report types allowed
export const TYPES_OF_REPORTS = {
  POEM: "POEM REPORT",
  ADVANCED_SURVEY: "ADVANCED SURVEY REPORT",
  EDIARY: "EDIARY REPORT",
  AI_SCORE: "AI SCORE REPORT",
  APP_PHOTO_SCORE: "APP PHOTO SCORE REPORT",
  EXTERNAL_PHOTO_SCORE: "EXTERNAL PHOTO SCORE REPORT",
  ECRF: "ECRF",
  VISIT: "VISIT REPORT",
  PHOTO: "PHOTO REPORT",
  VIDEO: "VIDEO REPORT",
  EXTERNAL_PHOTOS: "EXTERNAL PHOTO REPORT",
  EXTERNAL_VIDEOS: "EXTERNAL VIDEO REPORT",
  EXTERNAL_DOCUMENTS: "EXTERNAL DOCUMENT REPORT",
  ECONSENT: "ECONSENT REPORT",
  ECRF_CHANGE_LOGS: "ECRF CHANGE LOGS REPORT",
  QUERY_CHANGE_LOGS: "QUERY CHANGE LOGS REPORT",
  ECRF_DISCREPANCY: "ECRF DISCREPANCY REPORT",
  ECRF_BLOCKWISE: "ECRF BLOCKWISE REPORT",
  ECRF_FILLED_PDF: "ECRF FILLED PDF REPORT",
  POEM_FILLED_PDF: "POEM FILLED PDF REPORT",
  POEM_FILLED_PDF_INDIVIDUAL: "POEM FILLED PDF INDIVIDUAL REPORT",
};

export const DISCREPANCY_TYPES = [
  { value: "date_mismatch", label: "Date mismatch" },
  { value: "partially_filled", label: "Partially filled eCRFs" },
  { value: "out_of_range", label: "eCRFs with out of range values" },
];

export const BLOCK_STATUS_OPTIONS = [
  { value: "Frozen", label: "Frozen" },
  { value: "Unfrozen", label: "Unfrozen" },
  { value: "Certified", label: "Certified" },
  { value: "Uncertified", label: "Uncertified" },
];

// All roles of the system
export const USER_ROLES = {
  SUPER_ADMIN: "Super Admin",
  CRO: "CRO Admin",
  CRO_COORDINATOR: "Cro_coordinator",
  DATA_MANAGER: "Data Manager",
  INVESTIGATOR: "Investigator",
  CRC: "Inv_coordinator",
  SUB_INVESTIGATOR: "Sub_investigator",
  PRACTITIONER: "Practitioner",
  CLINIC_OWNER: "Clinic Owner",
  CLINIC_ADMIN: "Clinic Admin",
  CLINIC_INVENTORY_ADMIN: "Clinic Inventory Admin",
  REVIEWER: "Reviewer",
  SUPPORT_ADMIN: "Support Admin",
  PATIENT: "Patient",
};

// Investigator and Related Roles
export const INV_RELATED_ROLES = [
  USER_ROLES.INVESTIGATOR,
  USER_ROLES.CRC,
  USER_ROLES.SUB_INVESTIGATOR,
];

// Coordinator and Related Roles
export const CRO_RELATED_ROLES = [USER_ROLES.CRO, USER_ROLES.CRO_COORDINATOR];

// Roles that configure the eDiary of a trial
export const EDIARY_CONFIG_ROLES = [
  USER_ROLES.CRO,
  USER_ROLES.CRO_COORDINATOR,
  USER_ROLES.DATA_MANAGER,
  USER_ROLES.SUPER_ADMIN,
];

// Subject Statuses
export const SUBJECT_STATUSES = {
  CONTINUING: "Continuing",
  SCREENING_FAILED: "Screening Failed",
  PRE_SCREENING: "Pre-Screening",
  WITHDREW: "Withdrew",
  TERMINATED: "Terminated",
  COMPLETED: "Completed",
};

export const SUBJECT_STATUS_OPTIONS = Object.values(SUBJECT_STATUSES).map((value) => ({
  value,
  label: value,
}));

// Visit Statuses
export const VISIT_STATUSES = {
  NOT_OPENED: "Not Opened",
  INCOMPLETE: "InComplete",
  SKIPPED: "Skipped",
  COMPLETED: "Completed",
};

export const ECRF_STATUSES = {
  INCOMPLETE: "InComplete",
  NEUTRAL: "Neutral",
  COMPLETED: "Completed",
};

export const UPLOAD_TYPES = {
  APP_PHOTOS: "app_photos",
  APP_VIDEOS: "app_videos",
  EXTERNAL_PHOTOS: "external_photos",
  EXTERNAL_VIDEOS: "external_videos",
  EXTERNAL_DOCUMENTS: "external_documents",
  TRIAL_DOCUMENTS: "trial_documents",
  TRIAL_ARCHIVE_ECRF_PDF: "trial_archive_ecrf_pdf",
};
